import { FormInstance } from "antd/es/form";
import { Guid } from "guid-typescript";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IStation_View_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IStation_View_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GetUserWithGroupDetails: any[];
  GetUserWithGroupDetails_dummy: any[];
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  GetStationDetail: any[];
  GetStationDetail_dummy: any[];
  GetCustomerProductFile: any[];
  GetCustomerProductFile_dummy: any[];
  GetStationSpecificDocument: any[];
  GetStationSpecificDocument_dummy: any[];
  GetStationForecastByProductNameOrCode: any[];
  GetStationForecastByProductNameOrCode_dummy: any[];
  GetStationsBox: any[];
  GetStationsBox_dummy: any[];
  UploadFile: any[];
  UploadFile_dummy: any[];
  Base64PrefixRemove2: string;
  Base64PrefixRemove2_dummy: string;
  SaveCustomerProductsFromExcel: string;
  SaveCustomerProductsFromExcel_dummy: string;
  SaveComplexDataSingleStation3: string;
  SaveComplexDataSingleStation3_dummy: string;
  STDStationDocumentSave: number;
  STDStationDocumentSave_dummy: number;
  Notify: boolean;
  Notify_dummy: boolean;
  DownloadFile: any;
  DownloadFile_dummy: any;
  GetStationsBoxByProductNameOrCode: any[];
  GetStationsBoxByProductNameOrCode_dummy: any[];
  ChangeVisibilityOf: string;
  ChangeVisibilityOf_dummy: string;
  GetStationForecastForExcel: any[];
  GetStationForecastForExcel_dummy: any[];
  ExportExcel: any;
  ExportExcel_dummy: any;
  STDForecastDelete: number;
  STDForecastDelete_dummy: number;
  GetStationBoxesForExcel: any[];
  GetStationBoxesForExcel_dummy: any[];
  GenerateAndSaveLabelsForStation: any;
  GenerateAndSaveLabelsForStation_dummy: any;
  ZipFromLabels: string;
  ZipFromLabels_dummy: string;
  SaveStationLabelsZip: string;
  SaveStationLabelsZip_dummy: string;
  PrepareDownloadLink: string;
  PrepareDownloadLink_dummy: string;
  OpenInBrowser: any;
  OpenInBrowser_dummy: any;
  GetOrdersWithStationId: any[];
  GetOrdersWithStationId_dummy: any[];
  GetStationOrderForExcel: any[];
  GetStationOrderForExcel_dummy: any[];
  GetSapInfos: any[];
  GetSapInfos_dummy: any[];
  CreateOrdersForStation: any;
  CreateOrdersForStation_dummy: any;
  isComp663094Visible: "visible" | "hidden";
  isComp756824Visible: "visible" | "hidden";
  isComp758891Visible: "visible" | "hidden";
  isComp662274Visible: "visible" | "hidden";
  isComp65993Visible: "visible" | "hidden";
  isComp839301Visible: "visible" | "hidden";
  isComp428501Visible: "visible" | "hidden";
  isComp735311Visible: "visible" | "hidden";
  isComp271722Visible: "visible" | "hidden";
  isComp409198Visible: "visible" | "hidden";
  isComp630090Visible: "visible" | "hidden";
  isComp270670Visible: "visible" | "hidden";
  isComp615114Visible: "visible" | "hidden";
  isComp971315Visible: "visible" | "hidden";
  isComp986265Visible: "visible" | "hidden";
  isComp74018Visible: "visible" | "hidden";
  isComp195078Visible: "visible" | "hidden";
  isComp543229Visible: "visible" | "hidden";
  isComp630893Visible: "visible" | "hidden";
  isComp615348Visible: "visible" | "hidden";
  isComp46832Visible: "visible" | "hidden";

  isMasterPageInitLoaded?: boolean;
  isMasterPageRecurringLoaded?: boolean;
  shouldTriggerPageInit?: boolean;
}

export class Station_View_ScreenBase extends React.PureComponent<
  IStation_View_ScreenProps,
  any
> {
  station_view_780440_value_kuikaTableRef: React.RefObject<any>;
  station_view_654916_value_kuikaTableRef: React.RefObject<any>;
  station_view_894388_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "25c1b361-4262-e567-aef0-4b8ceff8261c",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "ea2af393-7864-0865-c06a-2b07d10d3ec8",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "5f3b7419-0cee-4ec7-aa93-f5170c478f36",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 71172, PropertyName: "value", Value: "Firma Adı" },
        { Id: 453528, PropertyName: "value", Value: "İstasyon Adı" },
        { Id: 649832, PropertyName: "value", Value: "İstasyon Lokasyonu" },
        { Id: 52255, PropertyName: "value", Value: "3215 Adet" },
        { Id: 735302, PropertyName: "value", Value: "4315 Adet" },
        { Id: 622211, PropertyName: "value", Value: "İstasyon ID" },
        { Id: 176364, PropertyName: "value", Value: "İstasyon Adresi" },
        { Id: 83102, PropertyName: "value", Value: "Oluşturulma Tarihi" },
        { Id: 747796, PropertyName: "value", Value: "Güncellenme Tarihi" },
        { Id: 278479, PropertyName: "value", Value: "Kanban Ek Adet" },
        {
          Id: 716376,
          PropertyName: "value",
          Value: "İstasyon Kurulum Dosyası",
        },
        {
          Id: 957894,
          PropertyName: "value",
          Value: "İstasyon Kurulum Dosyası",
        },
        { Id: 995515, PropertyName: "placeholder", Value: "Ürün kodu / Ürün" },
        { Id: 978577, PropertyName: "tab", Value: "İstasyon Öngörüsü" },
        { Id: 466993, PropertyName: "label", Value: "Dışa Aktar" },
        { Id: 382457, PropertyName: "title", Value: "Ürün Adı" },
        { Id: 223511, PropertyName: "value", Value: "[datafield:productname]" },
        { Id: 851114, PropertyName: "title", Value: "Ürün Kodu" },
        { Id: 508055, PropertyName: "value", Value: "[datafield:productcode]" },
        { Id: 190849, PropertyName: "title", Value: "Öngörülen Miktar" },
        {
          Id: 841386,
          PropertyName: "value",
          Value: "[datafield:expectedquantity]",
        },
        { Id: 64142, PropertyName: "title", Value: "Başlangıç Tarihi" },
        { Id: 535296, PropertyName: "value", Value: "[datafield:startdate]" },
        { Id: 744101, PropertyName: "title", Value: "Bitiş Tarihi" },
        { Id: 927756, PropertyName: "value", Value: "[datafield:enddate]" },
        { Id: 698647, PropertyName: "tab", Value: "Kutu Detayları" },
        { Id: 640697, PropertyName: "label", Value: "Dışa Aktar" },
        { Id: 734103, PropertyName: "value", Value: "Toplam Kutu Sayısı :" },
        { Id: 924693, PropertyName: "title", Value: "Kutu ID" },
        {
          Id: 949662,
          PropertyName: "value",
          Value: "[datafield:boxidentifier]",
        },
        { Id: 787953, PropertyName: "title", Value: "Müşteri Ürün Kodu" },
        {
          Id: 302762,
          PropertyName: "value",
          Value: "[datafield:customerproductcode]",
        },
        { Id: 447947, PropertyName: "title", Value: "Ürün Kodu" },
        { Id: 318580, PropertyName: "value", Value: "[datafield:productcode]" },
        { Id: 520707, PropertyName: "title", Value: "Ürün Adı" },
        { Id: 136947, PropertyName: "value", Value: "[datafield:productname]" },
        { Id: 680513, PropertyName: "title", Value: "Kutu İçi Adet" },
        {
          Id: 54330,
          PropertyName: "value",
          Value: "[datafield:expectedquantity]",
        },
        { Id: 242419, PropertyName: "title", Value: "Oluşturma Tarihi" },
        { Id: 716562, PropertyName: "value", Value: "[datafield:createdat]" },
        { Id: 987870, PropertyName: "title", Value: "Etiket Durumu" },
        {
          Id: 986265,
          PropertyName: "value",
          Value: "[datafield:etiketboolvalue]",
        },
        { Id: 511595, PropertyName: "tab", Value: "Siparişler" },
        { Id: 351859, PropertyName: "label", Value: "Dışa Aktar" },
        { Id: 412574, PropertyName: "title", Value: "Kutu ID" },
        {
          Id: 125422,
          PropertyName: "value",
          Value: "[datafield:boxidentifier]",
        },
        { Id: 799912, PropertyName: "title", Value: "Müşteri Ürün Kodu" },
        {
          Id: 764703,
          PropertyName: "value",
          Value: "[datafield:customerproductcode]",
        },
        { Id: 92446, PropertyName: "title", Value: "STenco Malzeme Kodu" },
        { Id: 252000, PropertyName: "value", Value: "[datafield:productcode]" },
        { Id: 426733, PropertyName: "title", Value: "STenco Malzeme Tanımı" },
        { Id: 448113, PropertyName: "value", Value: "[datafield:productname]" },
        { Id: 350030, PropertyName: "title", Value: "Kutu İçi Adet" },
        {
          Id: 664579,
          PropertyName: "value",
          Value: "[datafield:expectedquantity]",
        },
        { Id: 975798, PropertyName: "title", Value: "Oluşturma Tarihi" },
        { Id: 13934, PropertyName: "value", Value: "[datafield:createdate]" },
        { Id: 967821, PropertyName: "title", Value: "Sipariş No" },
        { Id: 913648, PropertyName: "value", Value: "[datafield:saporderid]" },
        { Id: 613147, PropertyName: "title", Value: "Durum" },
        { Id: 195078, PropertyName: "value", Value: "Kısmi Tamamlandı" },
        { Id: 543229, PropertyName: "value", Value: "Tamamlanmadı" },
        { Id: 630893, PropertyName: "value", Value: "Tamamlandı" },
        { Id: 615348, PropertyName: "value", Value: "Bekliyor" },
        { Id: 46832, PropertyName: "value", Value: "[datafield:siparisdurum]" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.station_view_995515_value_kuikaTextInputRef = React.createRef();
    this.station_view_780440_value_kuikaTableRef = React.createRef();
    this.station_view_654916_value_kuikaTableRef = React.createRef();
    this.station_view_894388_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GetUserWithGroupDetails: [],
      IfThenElse: false,
      GetStationDetail: [],
      GetCustomerProductFile: [],
      GetStationSpecificDocument: [],
      GetStationForecastByProductNameOrCode: [],
      GetStationsBox: [],
      UploadFile: [],
      Base64PrefixRemove2: "",
      DownloadFile: "",
      NAVIGATE: "",
      GetStationsBoxByProductNameOrCode: [],
      ChangeVisibilityOf: "",
      GetStationForecastForExcel: [],
      ExportExcel: "",
      STDForecastDelete: 0,
      GetStationBoxesForExcel: [],
      GenerateAndSaveLabelsForStation: "",
      ZipFromLabels: "",
      SaveStationLabelsZip: "",
      PrepareDownloadLink: "",
      OpenInBrowser: "",
      GetOrdersWithStationId: [],
      GetStationOrderForExcel: [],
      GetSapInfos: [],
      CreateOrdersForStation: "",
      isComp663094Visible: "visible",
      isComp756824Visible: "hidden",
      isComp758891Visible: "hidden",
      isComp662274Visible: "hidden",
      isComp65993Visible: "hidden",
      isComp839301Visible: "hidden",
      isComp428501Visible: "hidden",
      isComp735311Visible: "hidden",
      isComp271722Visible: "hidden",
      isComp409198Visible: "hidden",
      isComp630090Visible: "hidden",
      isComp270670Visible: "hidden",
      isComp615114Visible: "hidden",
      isComp971315Visible: "hidden",
      isComp986265Visible: "hidden",
      isComp74018Visible: "hidden",
      isComp195078Visible: "hidden",
      isComp543229Visible: "hidden",
      isComp630893Visible: "hidden",
      isComp615348Visible: "hidden",
      isComp46832Visible: "hidden",

      isMasterPageInitLoaded: false,
      isMasterPageRecurringLoaded: false,
      shouldTriggerPageInit: false,
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "station_view",
        "layout2_screen"
      );
      return;
    }

    ReactSystemFunctions.validateToken();
    if (false) {
      await this.Station_ViewPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("station_view", "layout2_screen");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("station_view", "layout2_screen");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.Station_ViewPageInit();
    }

    if (
      prevState.isMasterPageInitLoaded !== this.state.isMasterPageInitLoaded &&
      this.state.isMasterPageInitLoaded === true
    ) {
      await this.Station_ViewPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  checkTabErrors = () => {
    document.querySelectorAll(".rc-tabs-tab").forEach((tab) => {
      (tab as HTMLElement).style.color = "";
    });

    const tabPanes = document.querySelectorAll(".rc-tabs-tabpane");
    const tabs = document.querySelectorAll(".rc-tabs-tab");

    tabPanes.forEach((tabPane, index) => {
      const uniquePaneId = `rc-tabs-tabpane-${index}`;
      if (!tabPane.hasAttribute("id")) {
        tabPane.setAttribute("id", uniquePaneId);
      }

      const uniqueTabId = `rc-tabs-tab-${index}`;
      if (tabs[index]) {
        if (!tabs[index].hasAttribute("id")) {
          tabs[index].setAttribute("id", uniqueTabId);
        }
        tabs[index].setAttribute("aria-controls", uniquePaneId);
      }
    });

    const errorElements = document.querySelectorAll(
      ".rc-tabs .ant-form-item-explain-error"
    );

    const tabsWithErrors = new Set<string>();

    errorElements.forEach((errorElement) => {
      const tabPane = errorElement.closest(".rc-tabs-tabpane");
      if (tabPane && tabPane.id) {
        tabsWithErrors.add(tabPane.id);
      }
    });

    tabsWithErrors.forEach((tabPaneId) => {
      const tab = document.querySelector(
        `.rc-tabs-tab[aria-controls="${tabPaneId}"]`
      );
      if (tab) {
        (tab as HTMLElement).style.color = "red";
      }
    });
  };

  setMasterPageInitLoaded = (value: boolean) => {
    this.setState({ isMasterPageInitLoaded: value });
  };

  setMasterPageRecurringLoaded = (value: boolean) => {
    this.setState({ isMasterPageRecurringLoaded: value });
  };
  setShouldTriggerPageInit = (value: boolean) => {
    this.setState({ shouldTriggerPageInit: value });
  };

  Station_ViewPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Station_View/Station_ViewPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetUserWithGroupDetails = result?.data.getUserWithGroupDetails;
    stateVars.isComp662274Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].stationsCreate
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].stationsCreate
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp839301Visible =
      (ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].stationsEdit
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].stationsEdit
            : null
        ),
        true
      ) ||
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.value(
            this,
            stateVars.GetUserWithGroupDetails !== undefined
              ? stateVars.GetUserWithGroupDetails?.length > 0
                ? stateVars.GetUserWithGroupDetails[0].stationsCreate
                : null
              : this.state.GetUserWithGroupDetails?.length > 0
              ? this.state.GetUserWithGroupDetails[0].stationsCreate
              : null
          ),
          true
        )) === true
        ? "visible"
        : "hidden";
    stateVars.isComp428501Visible =
      (ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].stationsEdit
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].stationsEdit
            : null
        ),
        true
      ) ||
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.value(
            this,
            stateVars.GetUserWithGroupDetails !== undefined
              ? stateVars.GetUserWithGroupDetails?.length > 0
                ? stateVars.GetUserWithGroupDetails[0].stationsCreate
                : null
              : this.state.GetUserWithGroupDetails?.length > 0
              ? this.state.GetUserWithGroupDetails[0].stationsCreate
              : null
          ),
          true
        )) === true
        ? "visible"
        : "hidden";
    stateVars.isComp735311Visible =
      (ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].stationsEdit
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].stationsEdit
            : null
        ),
        true
      ) &&
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.value(
            this,
            stateVars.GetUserWithGroupDetails !== undefined
              ? stateVars.GetUserWithGroupDetails?.length > 0
                ? stateVars.GetUserWithGroupDetails[0].stationsCreate
                : null
              : this.state.GetUserWithGroupDetails?.length > 0
              ? this.state.GetUserWithGroupDetails[0].stationsCreate
              : null
          ),
          true
        )) === true
        ? "visible"
        : "hidden";
    stateVars.isComp271722Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].boxCreate
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].boxCreate
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp74018Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].boxEdit
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].boxEdit
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.Station_ViewPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  Station_ViewPageInit_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Station_View",
      "NavigateScreen",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  Station_ViewPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].stationsView
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].stationsView
            : null
        ),
        true
      )
    ) {
      isErrorOccurred = await this.Station_ViewPageInit_if1();
      if (isErrorOccurred) return true;
    } else {
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.Station_ViewPageInit2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  Station_ViewPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      CustomerId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStationDetail !== undefined
            ? stateVars.GetStationDetail?.length > 0
              ? stateVars.GetStationDetail[0].customerId
              : null
            : this.state.GetStationDetail?.length > 0
            ? this.state.GetStationDetail[0].customerId
            : null
        ),
        "Guid"
      ),
      StationId_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      StationId_3: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      Search_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "station_view_995515_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Id_4: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Station_View/Station_ViewPageInit2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetStationDetail = result?.data.getStationDetail;
    formVars.station_view_640534_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStationDetail !== undefined
        ? stateVars.GetStationDetail?.length > 0
          ? stateVars.GetStationDetail[0].name
          : null
        : this.state.GetStationDetail?.length > 0
        ? this.state.GetStationDetail[0].name
        : null
    );
    formVars.station_view_355706_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStationDetail !== undefined
        ? stateVars.GetStationDetail?.length > 0
          ? stateVars.GetStationDetail[0].stationName
          : null
        : this.state.GetStationDetail?.length > 0
        ? this.state.GetStationDetail[0].stationName
        : null
    );
    formVars.station_view_125195_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStationDetail !== undefined
        ? stateVars.GetStationDetail?.length > 0
          ? stateVars.GetStationDetail[0].stationLocation
          : null
        : this.state.GetStationDetail?.length > 0
        ? this.state.GetStationDetail[0].stationLocation
        : null
    );
    formVars.station_view_757868_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStationDetail !== undefined
        ? stateVars.GetStationDetail?.length > 0
          ? stateVars.GetStationDetail[0].total3215
          : null
        : this.state.GetStationDetail?.length > 0
        ? this.state.GetStationDetail[0].total3215
        : null
    );
    formVars.station_view_217729_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStationDetail !== undefined
        ? stateVars.GetStationDetail?.length > 0
          ? stateVars.GetStationDetail[0].total4315
          : null
        : this.state.GetStationDetail?.length > 0
        ? this.state.GetStationDetail[0].total4315
        : null
    );
    formVars.station_view_836474_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStationDetail !== undefined
        ? stateVars.GetStationDetail?.length > 0
          ? stateVars.GetStationDetail[0].stationIdentifier
          : null
        : this.state.GetStationDetail?.length > 0
        ? this.state.GetStationDetail[0].stationIdentifier
        : null
    );
    formVars.station_view_815030_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStationDetail !== undefined
        ? stateVars.GetStationDetail?.length > 0
          ? stateVars.GetStationDetail[0].stationAddress
          : null
        : this.state.GetStationDetail?.length > 0
        ? this.state.GetStationDetail[0].stationAddress
        : null
    );
    formVars.station_view_373963_value = ReactSystemFunctions.value(
      this,
      stateVars.GetStationDetail !== undefined
        ? stateVars.GetStationDetail?.length > 0
          ? stateVars.GetStationDetail[0].createdAt
          : null
        : this.state.GetStationDetail?.length > 0
        ? this.state.GetStationDetail[0].createdAt
        : null
    );
    formVars.station_view_988614_value = ReactSystemFunctions.value(
      this,
      stateVars.GetStationDetail !== undefined
        ? stateVars.GetStationDetail?.length > 0
          ? stateVars.GetStationDetail[0].updatedAt
          : null
        : this.state.GetStationDetail?.length > 0
        ? this.state.GetStationDetail[0].updatedAt
        : null
    );
    formVars.station_view_752186_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStationDetail !== undefined
        ? stateVars.GetStationDetail?.length > 0
          ? stateVars.GetStationDetail[0].totalKanbanEk
          : null
        : this.state.GetStationDetail?.length > 0
        ? this.state.GetStationDetail[0].totalKanbanEk
        : null
    );
    formVars.station_view_210982_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStationDetail !== undefined
        ? stateVars.GetStationDetail?.length > 0
          ? stateVars.GetStationDetail[0].totalBoxes
          : null
        : this.state.GetStationDetail?.length > 0
        ? this.state.GetStationDetail[0].totalBoxes
        : null
    );
    stateVars.GetCustomerProductFile = result?.data.getCustomerProductFile;
    stateVars.isComp758891Visible =
      (ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStationsBox !== undefined
            ? stateVars.GetStationsBox?.length > 0
              ? stateVars.GetStationsBox[0].id
              : null
            : this.state.GetStationsBox?.length > 0
            ? this.state.GetStationsBox[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) &&
        ReactSystemFunctions.isNotEmpty(
          ReactSystemFunctions.toString(
            this,
            stateVars.GetCustomerProductFile !== undefined
              ? stateVars.GetCustomerProductFile?.length > 0
                ? stateVars.GetCustomerProductFile[0].fileData
                : null
              : this.state.GetCustomerProductFile?.length > 0
              ? this.state.GetCustomerProductFile[0].fileData
              : null
          ),
          ReactSystemFunctions.convertToTypeByName("True", "string")
        )) === true
        ? "visible"
        : "hidden";
    stateVars.GetStationSpecificDocument =
      result?.data.getStationSpecificDocument;
    formVars.station_view_782723_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStationSpecificDocument !== undefined
        ? stateVars.GetStationSpecificDocument?.length > 0
          ? stateVars.GetStationSpecificDocument[0].docName
          : null
        : this.state.GetStationSpecificDocument?.length > 0
        ? this.state.GetStationSpecificDocument[0].docName
        : null
    );
    formVars.station_view_782723_tooltip = ReactSystemFunctions.toString(
      this,
      stateVars.GetStationSpecificDocument !== undefined
        ? stateVars.GetStationSpecificDocument?.length > 0
          ? stateVars.GetStationSpecificDocument[0].docName
          : null
        : this.state.GetStationSpecificDocument?.length > 0
        ? this.state.GetStationSpecificDocument[0].docName
        : null
    );
    stateVars.isComp65993Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStationSpecificDocument !== undefined
            ? stateVars.GetStationSpecificDocument?.length > 0
              ? stateVars.GetStationSpecificDocument[0].id
              : null
            : this.state.GetStationSpecificDocument?.length > 0
            ? this.state.GetStationSpecificDocument[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.GetStationForecastByProductNameOrCode =
      result?.data.getStationForecastByProductNameOrCode;

    stateVars.GetStationsBox = result?.data.getStationsBox;
    stateVars.isComp758891Visible =
      (ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStationsBox !== undefined
            ? stateVars.GetStationsBox?.length > 0
              ? stateVars.GetStationsBox[0].id
              : null
            : this.state.GetStationsBox?.length > 0
            ? this.state.GetStationsBox[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) &&
        ReactSystemFunctions.isNotEmpty(
          ReactSystemFunctions.toString(
            this,
            stateVars.GetCustomerProductFile !== undefined
              ? stateVars.GetCustomerProductFile?.length > 0
                ? stateVars.GetCustomerProductFile[0].fileData
                : null
              : this.state.GetCustomerProductFile?.length > 0
              ? this.state.GetCustomerProductFile[0].fileData
              : null
          ),
          ReactSystemFunctions.convertToTypeByName("True", "string")
        )) === true
        ? "visible"
        : "hidden";
    stateVars.isComp409198Visible =
      ReactSystemFunctions.isGreaterOrEqual(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStationsBox !== undefined
            ? stateVars.GetStationsBox?.length > 0
              ? stateVars.GetStationsBox[0].noLabelValue
              : null
            : this.state.GetStationsBox?.length > 0
            ? this.state.GetStationsBox[0].noLabelValue
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp270670Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStationsBox !== undefined
            ? stateVars.GetStationsBox?.length > 0
              ? stateVars.GetStationsBox[0].noLabelValue
              : null
            : this.state.GetStationsBox?.length > 0
            ? this.state.GetStationsBox[0].noLabelValue
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.Station_ViewPageInit3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  Station_ViewPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.station_view_640534_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStationDetail !== undefined
        ? stateVars.GetStationDetail?.length > 0
          ? stateVars.GetStationDetail[0].name
          : null
        : this.state.GetStationDetail?.length > 0
        ? this.state.GetStationDetail[0].name
        : null
    );

    formVars.station_view_355706_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStationDetail !== undefined
        ? stateVars.GetStationDetail?.length > 0
          ? stateVars.GetStationDetail[0].stationName
          : null
        : this.state.GetStationDetail?.length > 0
        ? this.state.GetStationDetail[0].stationName
        : null
    );

    formVars.station_view_125195_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStationDetail !== undefined
        ? stateVars.GetStationDetail?.length > 0
          ? stateVars.GetStationDetail[0].stationLocation
          : null
        : this.state.GetStationDetail?.length > 0
        ? this.state.GetStationDetail[0].stationLocation
        : null
    );

    formVars.station_view_757868_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStationDetail !== undefined
        ? stateVars.GetStationDetail?.length > 0
          ? stateVars.GetStationDetail[0].total3215
          : null
        : this.state.GetStationDetail?.length > 0
        ? this.state.GetStationDetail[0].total3215
        : null
    );

    formVars.station_view_217729_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStationDetail !== undefined
        ? stateVars.GetStationDetail?.length > 0
          ? stateVars.GetStationDetail[0].total4315
          : null
        : this.state.GetStationDetail?.length > 0
        ? this.state.GetStationDetail[0].total4315
        : null
    );

    formVars.station_view_836474_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStationDetail !== undefined
        ? stateVars.GetStationDetail?.length > 0
          ? stateVars.GetStationDetail[0].stationIdentifier
          : null
        : this.state.GetStationDetail?.length > 0
        ? this.state.GetStationDetail[0].stationIdentifier
        : null
    );

    formVars.station_view_815030_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStationDetail !== undefined
        ? stateVars.GetStationDetail?.length > 0
          ? stateVars.GetStationDetail[0].stationAddress
          : null
        : this.state.GetStationDetail?.length > 0
        ? this.state.GetStationDetail[0].stationAddress
        : null
    );

    formVars.station_view_373963_value = ReactSystemFunctions.value(
      this,
      stateVars.GetStationDetail !== undefined
        ? stateVars.GetStationDetail?.length > 0
          ? stateVars.GetStationDetail[0].createdAt
          : null
        : this.state.GetStationDetail?.length > 0
        ? this.state.GetStationDetail[0].createdAt
        : null
    );

    formVars.station_view_988614_value = ReactSystemFunctions.value(
      this,
      stateVars.GetStationDetail !== undefined
        ? stateVars.GetStationDetail?.length > 0
          ? stateVars.GetStationDetail[0].updatedAt
          : null
        : this.state.GetStationDetail?.length > 0
        ? this.state.GetStationDetail[0].updatedAt
        : null
    );

    formVars.station_view_752186_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStationDetail !== undefined
        ? stateVars.GetStationDetail?.length > 0
          ? stateVars.GetStationDetail[0].totalKanbanEk
          : null
        : this.state.GetStationDetail?.length > 0
        ? this.state.GetStationDetail[0].totalKanbanEk
        : null
    );

    stateVars.isComp758891Visible =
      (ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStationsBox !== undefined
            ? stateVars.GetStationsBox?.length > 0
              ? stateVars.GetStationsBox[0].id
              : null
            : this.state.GetStationsBox?.length > 0
            ? this.state.GetStationsBox[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) &&
        ReactSystemFunctions.isNotEmpty(
          ReactSystemFunctions.toString(
            this,
            stateVars.GetCustomerProductFile !== undefined
              ? stateVars.GetCustomerProductFile?.length > 0
                ? stateVars.GetCustomerProductFile[0].fileData
                : null
              : this.state.GetCustomerProductFile?.length > 0
              ? this.state.GetCustomerProductFile[0].fileData
              : null
          ),
          ReactSystemFunctions.convertToTypeByName("True", "string")
        )) === true
        ? "visible"
        : "hidden";
    stateVars.isComp662274Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].stationsCreate
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].stationsCreate
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp65993Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStationSpecificDocument !== undefined
            ? stateVars.GetStationSpecificDocument?.length > 0
              ? stateVars.GetStationSpecificDocument[0].id
              : null
            : this.state.GetStationSpecificDocument?.length > 0
            ? this.state.GetStationSpecificDocument[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.station_view_782723_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStationSpecificDocument !== undefined
        ? stateVars.GetStationSpecificDocument?.length > 0
          ? stateVars.GetStationSpecificDocument[0].docName
          : null
        : this.state.GetStationSpecificDocument?.length > 0
        ? this.state.GetStationSpecificDocument[0].docName
        : null
    );
    formVars.station_view_782723_tooltip = ReactSystemFunctions.toString(
      this,
      stateVars.GetStationSpecificDocument !== undefined
        ? stateVars.GetStationSpecificDocument?.length > 0
          ? stateVars.GetStationSpecificDocument[0].docName
          : null
        : this.state.GetStationSpecificDocument?.length > 0
        ? this.state.GetStationSpecificDocument[0].docName
        : null
    );

    formVars.station_view_782723_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStationSpecificDocument !== undefined
        ? stateVars.GetStationSpecificDocument?.length > 0
          ? stateVars.GetStationSpecificDocument[0].docName
          : null
        : this.state.GetStationSpecificDocument?.length > 0
        ? this.state.GetStationSpecificDocument[0].docName
        : null
    );
    formVars.station_view_782723_tooltip = ReactSystemFunctions.toString(
      this,
      stateVars.GetStationSpecificDocument !== undefined
        ? stateVars.GetStationSpecificDocument?.length > 0
          ? stateVars.GetStationSpecificDocument[0].docName
          : null
        : this.state.GetStationSpecificDocument?.length > 0
        ? this.state.GetStationSpecificDocument[0].docName
        : null
    );

    stateVars.isComp839301Visible =
      (ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].stationsEdit
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].stationsEdit
            : null
        ),
        true
      ) ||
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.value(
            this,
            stateVars.GetUserWithGroupDetails !== undefined
              ? stateVars.GetUserWithGroupDetails?.length > 0
                ? stateVars.GetUserWithGroupDetails[0].stationsCreate
                : null
              : this.state.GetUserWithGroupDetails?.length > 0
              ? this.state.GetUserWithGroupDetails[0].stationsCreate
              : null
          ),
          true
        )) === true
        ? "visible"
        : "hidden";
    stateVars.isComp428501Visible =
      (ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].stationsEdit
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].stationsEdit
            : null
        ),
        true
      ) ||
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.value(
            this,
            stateVars.GetUserWithGroupDetails !== undefined
              ? stateVars.GetUserWithGroupDetails?.length > 0
                ? stateVars.GetUserWithGroupDetails[0].stationsCreate
                : null
              : this.state.GetUserWithGroupDetails?.length > 0
              ? this.state.GetUserWithGroupDetails[0].stationsCreate
              : null
          ),
          true
        )) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_780440 =
      stateVars.GetStationForecastByProductNameOrCode ??
      this.state.GetStationForecastByProductNameOrCode;
    stateVars.isComp735311Visible =
      (ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].stationsEdit
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].stationsEdit
            : null
        ),
        true
      ) &&
        ReactSystemFunctions.isEqualTo(
          ReactSystemFunctions.value(
            this,
            stateVars.GetUserWithGroupDetails !== undefined
              ? stateVars.GetUserWithGroupDetails?.length > 0
                ? stateVars.GetUserWithGroupDetails[0].stationsCreate
                : null
              : this.state.GetUserWithGroupDetails?.length > 0
              ? this.state.GetUserWithGroupDetails[0].stationsCreate
              : null
          ),
          true
        )) === true
        ? "visible"
        : "hidden";

    formVars.station_view_210982_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStationDetail !== undefined
        ? stateVars.GetStationDetail?.length > 0
          ? stateVars.GetStationDetail[0].totalBoxes
          : null
        : this.state.GetStationDetail?.length > 0
        ? this.state.GetStationDetail[0].totalBoxes
        : null
    );

    stateVars.isComp271722Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].boxCreate
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].boxCreate
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp409198Visible =
      ReactSystemFunctions.isGreaterOrEqual(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStationsBox !== undefined
            ? stateVars.GetStationsBox?.length > 0
              ? stateVars.GetStationsBox[0].noLabelValue
              : null
            : this.state.GetStationsBox?.length > 0
            ? this.state.GetStationsBox[0].noLabelValue
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp270670Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStationsBox !== undefined
            ? stateVars.GetStationsBox?.length > 0
              ? stateVars.GetStationsBox[0].noLabelValue
              : null
            : this.state.GetStationsBox?.length > 0
            ? this.state.GetStationsBox[0].noLabelValue
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";

    stateVars.isComp615114Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "station_view_654916_value",
          "etiketBoolValue"
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp971315Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "station_view_654916_value",
          "etiketBoolValue"
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp74018Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].boxEdit
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].boxEdit
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp756824Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetOrdersWithStationId !== undefined
            ? stateVars.GetOrdersWithStationId?.length > 0
              ? stateVars.GetOrdersWithStationId[0].id
              : null
            : this.state.GetOrdersWithStationId?.length > 0
            ? this.state.GetOrdersWithStationId[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp195078Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "station_view_894388_value",
          "orderStatus"
        ),
        ReactSystemFunctions.convertToTypeByName("4", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp543229Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "station_view_894388_value",
          "orderStatus"
        ),
        ReactSystemFunctions.convertToTypeByName("5", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp630893Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "station_view_894388_value",
          "orderStatus"
        ),
        ReactSystemFunctions.convertToTypeByName("3", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp615348Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "station_view_894388_value",
          "orderStatus"
        ),
        ReactSystemFunctions.convertToTypeByName("2", "string")
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  Station_ViewComponent_662274_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.UploadFile = (
      (await ReactSystemFunctions.uploadFilesWithInfo(
        ReactSystemFunctions.convertToTypeByName("", "string")
      )) as any
    ).data;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.Station_ViewComponent_662274_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  Station_ViewComponent_662274_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      base64_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.UploadFile !== undefined
            ? stateVars.UploadFile?.length > 0
              ? stateVars.UploadFile[0].data
              : null
            : this.state.UploadFile?.length > 0
            ? this.state.UploadFile[0].data
            : null
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Station_View/Station_ViewComponent_662274_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Base64PrefixRemove2 = result?.data.base64PrefixRemove2;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.Station_ViewComponent_662274_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  Station_ViewComponent_662274_onClick_if2 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.Station_ViewComponent_662274_onClick_if21_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  Station_ViewComponent_662274_onClick_if2f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.Station_ViewComponent_662274_onClick_if2f11_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  Station_ViewComponent_662274_onClick_if2f1f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      base64Data_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.Base64PrefixRemove2),
        "string"
      ),
      customerId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStationDetail !== undefined
            ? stateVars.GetStationDetail?.length > 0
              ? stateVars.GetStationDetail[0].customerId
              : null
            : this.state.GetStationDetail?.length > 0
            ? this.state.GetStationDetail[0].customerId
            : null
        ),
        "Guid"
      ),
      base64Data_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.Base64PrefixRemove2),
        "string"
      ),
      customerId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationDetail !== undefined
            ? stateVars.GetStationDetail?.length > 0
              ? stateVars.GetStationDetail[0].customerId
              : null
            : this.state.GetStationDetail?.length > 0
            ? this.state.GetStationDetail[0].customerId
            : null
        ),
        "string"
      ),
      stationCode_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStationDetail !== undefined
            ? stateVars.GetStationDetail?.length > 0
              ? stateVars.GetStationDetail[0].stationIdentifier
              : null
            : this.state.GetStationDetail?.length > 0
            ? this.state.GetStationDetail[0].stationIdentifier
            : null
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Station_View/Station_ViewComponent_662274_onClick_if2f1f1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SaveCustomerProductsFromExcel =
      result?.data.saveCustomerProductsFromExcel;
    stateVars.SaveComplexDataSingleStation3 =
      result?.data.saveComplexDataSingleStation3;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.Station_ViewComponent_662274_onClick_if2f1f11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  Station_ViewComponent_662274_onClick_if2f1f1f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      DocData_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.UploadFile !== undefined
            ? stateVars.UploadFile?.length > 0
              ? stateVars.UploadFile[0].data
              : null
            : this.state.UploadFile?.length > 0
            ? this.state.UploadFile[0].data
            : null
        ),
        "string"
      ),
      DocName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.UploadFile !== undefined
            ? stateVars.UploadFile?.length > 0
              ? stateVars.UploadFile[0].name
              : null
            : this.state.UploadFile?.length > 0
            ? this.state.UploadFile[0].name
            : null
        ),
        "string"
      ),
      StationId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStationDetail !== undefined
            ? stateVars.GetStationDetail?.length > 0
              ? stateVars.GetStationDetail[0].id
              : null
            : this.state.GetStationDetail?.length > 0
            ? this.state.GetStationDetail[0].id
            : null
        ),
        "Guid"
      ),
      Id_0: ReactSystemFunctions.convertToTypeByName(
        Guid.create().toString(),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Station_View/Station_ViewComponent_662274_onClick_if2f1f1f1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.STDStationDocumentSave = result?.data.stdStationDocumentSave;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  Station_ViewComponent_662274_onClick_if2f1f11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStationSpecificDocument !== undefined
            ? stateVars.GetStationSpecificDocument?.length > 0
              ? stateVars.GetStationSpecificDocument[0].id
              : null
            : this.state.GetStationSpecificDocument?.length > 0
            ? this.state.GetStationSpecificDocument[0].id
            : null
        ),
        true
      )
    ) {
      isErrorOccurred =
        await this.Station_ViewComponent_662274_onClick_if2f1f1f1();
      if (isErrorOccurred) return true;
    } else {
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "efc851dd_0b14_ad1c_900e_e691f0fc907b_notify",
        this.defaultML,
        "Kurulum dosyası başarıyla işlendi."
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom", "string"),
      5,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "Station_View",
      "Id",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Station_View",
      "Station_View",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  Station_ViewComponent_662274_onClick_if2f1e1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "62afef3d_0349_e8ae_9863_8b8394c89f2e_notify",
        this.defaultML,
        "deneme 123"
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom", "string"),
      5,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  Station_ViewComponent_662274_onClick_if2f11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStationDetail !== undefined
            ? stateVars.GetStationDetail?.length > 0
              ? stateVars.GetStationDetail[0].id
              : null
            : this.state.GetStationDetail?.length > 0
            ? this.state.GetStationDetail[0].id
            : null
        ),
        true
      )
    ) {
      isErrorOccurred =
        await this.Station_ViewComponent_662274_onClick_if2f1f1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.Station_ViewComponent_662274_onClick_if2f1e1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  Station_ViewComponent_662274_onClick_if2e1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "adc66f60_70fe_e8a5_17f1_45012e111e9f_notify",
        this.defaultML,
        "Müşteriye ait tanımlı istasyon bulunamadı!"
      ),
      ReactSystemFunctions.convertToTypeByName("warning", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      5,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  Station_ViewComponent_662274_onClick_if21_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStationDetail !== undefined
            ? stateVars.GetStationDetail?.length > 0
              ? stateVars.GetStationDetail[0].id
              : null
            : this.state.GetStationDetail?.length > 0
            ? this.state.GetStationDetail[0].id
            : null
        ),
        true
      )
    ) {
      isErrorOccurred = await this.Station_ViewComponent_662274_onClick_if2f1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred = await this.Station_ViewComponent_662274_onClick_if2e1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  Station_ViewComponent_662274_onClick_else2 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "f5db21d7_4bbf_83b9_adbf_65fa4da3bcf5_notify",
        this.defaultML,
        "Dosya yüklenmedi!"
      ),
      ReactSystemFunctions.convertToTypeByName("info", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom", "string"),
      5,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  Station_ViewComponent_662274_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.UploadFile !== undefined
            ? stateVars.UploadFile?.length > 0
              ? stateVars.UploadFile[0].data
              : null
            : this.state.UploadFile?.length > 0
            ? this.state.UploadFile[0].data
            : null
        ),
        true
      )
    ) {
      isErrorOccurred = await this.Station_ViewComponent_662274_onClick_if2();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred = await this.Station_ViewComponent_662274_onClick_else2();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  Station_ViewComponent_435118_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.DownloadFile = await ReactSystemFunctions.downloadFile(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetStationSpecificDocument !== undefined
          ? stateVars.GetStationSpecificDocument?.length > 0
            ? stateVars.GetStationSpecificDocument[0].docData
            : null
          : this.state.GetStationSpecificDocument?.length > 0
          ? this.state.GetStationSpecificDocument[0].docData
          : null
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.GetStationSpecificDocument !== undefined
          ? stateVars.GetStationSpecificDocument?.length > 0
            ? stateVars.GetStationSpecificDocument[0].docName
            : null
          : this.state.GetStationSpecificDocument?.length > 0
          ? this.state.GetStationSpecificDocument[0].docName
          : null
      )
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  Station_ViewComponent_839301_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "STDStations_Form",
      "Id",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Station_View",
      "STDStations_Form",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "16963",
      null,
      "right",
      "true",
      "380px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  Station_ViewComponent_995515_onPressEnter = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      Search_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "station_view_995515_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      StationId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      Search_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "station_view_995515_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Station_View/Station_ViewComponent_995515_onPressEnter",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetStationsBoxByProductNameOrCode =
      result?.data.getStationsBoxByProductNameOrCode;

    stateVars.GetStationForecastByProductNameOrCode =
      result?.data.getStationForecastByProductNameOrCode;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.Station_ViewComponent_995515_onPressEnter1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  Station_ViewComponent_995515_onPressEnter1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_780440 =
      stateVars.GetStationForecastByProductNameOrCode ??
      this.state.GetStationForecastByProductNameOrCode;

    stateVars.dataSource_654916 =
      stateVars.GetStationsBoxByProductNameOrCode ??
      this.state.GetStationsBoxByProductNameOrCode;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  Station_ViewComponent_978577_onActive = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp663094Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  Station_ViewComponent_466993_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      StationId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      Search_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "station_view_995515_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      value_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, stateVars.GetStationForecastForExcel),
        "any"
      ),
      header_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      footer_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      columns_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Station_View/Station_ViewComponent_466993_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetStationForecastForExcel =
      result?.data.getStationForecastForExcel;
    stateVars.ExportExcel = result?.data.exportExcel;
    ReactSystemFunctions.downloadFile(result?.data?.exportExcel);
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  Station_ViewComponent_428501_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "AddForeCast",
      "StationId",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "AddForeCast",
      "ForecastId",
      ReactSystemFunctions.convertToTypeByName(Guid.create().toString(), "Guid")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Station_View",
      "AddForeCast",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "332376",
      null,
      null,
      "true",
      "800px",
      "70vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  Station_ViewComponent_223511_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].productsView
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].productsView
            : null
        ),
        true
      )
    ) {
      KuikaAppManager.showSpinner(this);

      KuikaAppManager.prepareForNavigation();
      KuikaAppManager.addToPageInputVariables(
        "STDProducts_View",
        "Id",
        ReactSystemFunctions.convertToTypeByName(
          ReactSystemFunctions.value(
            this,
            "station_view_780440_value",
            "productId"
          ),
          "Guid"
        )
      );

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        undefined,
        "Station_View",
        "STDProducts_View",
        "",
        "7d969ddf-5801-4eb6-b92b-12be35bdd565",
        "546395",
        null,
        "right",
        "true",
        "602px",
        "100vh",
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  Station_ViewComponent_866985_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "AddForeCast",
      "StationId",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "AddForeCast",
      "ForecastId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "station_view_780440_value", "id"),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Station_View",
      "AddForeCast",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "518991",
      null,
      null,
      "true",
      "800px",
      "70vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  Station_ViewComponent_735311_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "station_view_780440_value", "id"),
        "Guid"
      ),
      StationId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      Search_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "station_view_995515_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    stateVars.Confirm = await ReactSystemFunctions.confirmation(
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "34cee1a8_cd8c_89ea_d5a8_6876dbffcc03_confirmation",
        this.defaultML,
        "Öngörüyü kaldırmak istediğinize emin misiniz?"
      ),
      "poppins",
      "Öngörü Kaldır",
      "trash",
      "#ee1111"
    );

    if (stateVars.Confirm) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "Station_View/Station_ViewComponent_735311_onClick",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.STDForecastDelete = result?.data.stdForecastDelete;
      stateVars.GetStationForecastByProductNameOrCode =
        result?.data.getStationForecastByProductNameOrCode;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.Station_ViewComponent_735311_onClick1_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  Station_ViewComponent_735311_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_780440 =
      stateVars.GetStationForecastByProductNameOrCode ??
      this.state.GetStationForecastByProductNameOrCode;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  Station_ViewComponent_698647_onActive = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      Search_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "station_view_995515_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Station_View/Station_ViewComponent_698647_onActive",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetStationsBoxByProductNameOrCode =
      result?.data.getStationsBoxByProductNameOrCode;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.Station_ViewComponent_698647_onActive1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  Station_ViewComponent_698647_onActive1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp663094Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );

    stateVars.dataSource_654916 =
      stateVars.GetStationsBoxByProductNameOrCode ??
      this.state.GetStationsBoxByProductNameOrCode;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  Station_ViewComponent_640697_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      Search_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "station_view_995515_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      value_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, stateVars.GetStationBoxesForExcel),
        "any"
      ),
      header_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      footer_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      columns_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Station_View/Station_ViewComponent_640697_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetStationBoxesForExcel = result?.data.getStationBoxesForExcel;
    stateVars.ExportExcel = result?.data.exportExcel;
    ReactSystemFunctions.downloadFile(result?.data?.exportExcel);
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  Station_ViewComponent_271722_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "STDBoxes_Form_Manuel",
      "Id",
      ReactSystemFunctions.convertToTypeByName(Guid.create().toString(), "Guid")
    );
    KuikaAppManager.addToPageInputVariables(
      "STDBoxes_Form_Manuel",
      "stationId",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      this.Station_ViewComponent_271722_onClick1_,
      "Station_View",
      "STDBoxes_Form_Manuel",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "265858",
      null,
      "right",
      "true",
      "500px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };
  Station_ViewComponent_271722_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      Search_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "station_view_995515_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Station_View/Station_ViewComponent_271722_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetStationsBoxByProductNameOrCode =
      result?.data.getStationsBoxByProductNameOrCode;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.Station_ViewComponent_271722_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  Station_ViewComponent_271722_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_654916 =
      stateVars.GetStationsBoxByProductNameOrCode ??
      this.state.GetStationsBoxByProductNameOrCode;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  Station_ViewComponent_409198_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      stationId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      labelType_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationDetail !== undefined
            ? stateVars.GetStationDetail?.length > 0
              ? stateVars.GetStationDetail[0].name
              : null
            : this.state.GetStationDetail?.length > 0
            ? this.state.GetStationDetail[0].name
            : null
        ),
        "string"
      ),
      Id_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      Search_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "station_view_995515_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Id_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Station_View/Station_ViewComponent_409198_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetStationsBoxByProductNameOrCode =
      result?.data.getStationsBoxByProductNameOrCode;

    stateVars.GetStationsBox = result?.data.getStationsBox;
    stateVars.isComp758891Visible =
      (ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStationsBox !== undefined
            ? stateVars.GetStationsBox?.length > 0
              ? stateVars.GetStationsBox[0].id
              : null
            : this.state.GetStationsBox?.length > 0
            ? this.state.GetStationsBox[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) &&
        ReactSystemFunctions.isNotEmpty(
          ReactSystemFunctions.toString(
            this,
            stateVars.GetCustomerProductFile !== undefined
              ? stateVars.GetCustomerProductFile?.length > 0
                ? stateVars.GetCustomerProductFile[0].fileData
                : null
              : this.state.GetCustomerProductFile?.length > 0
              ? this.state.GetCustomerProductFile[0].fileData
              : null
          ),
          ReactSystemFunctions.convertToTypeByName("True", "string")
        )) === true
        ? "visible"
        : "hidden";
    stateVars.isComp409198Visible =
      ReactSystemFunctions.isGreaterOrEqual(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStationsBox !== undefined
            ? stateVars.GetStationsBox?.length > 0
              ? stateVars.GetStationsBox[0].noLabelValue
              : null
            : this.state.GetStationsBox?.length > 0
            ? this.state.GetStationsBox[0].noLabelValue
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("1", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp270670Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStationsBox !== undefined
            ? stateVars.GetStationsBox?.length > 0
              ? stateVars.GetStationsBox[0].noLabelValue
              : null
            : this.state.GetStationsBox?.length > 0
            ? this.state.GetStationsBox[0].noLabelValue
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.Station_ViewComponent_409198_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  Station_ViewComponent_409198_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_654916 =
      stateVars.GetStationsBoxByProductNameOrCode ??
      this.state.GetStationsBoxByProductNameOrCode;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  Station_ViewComponent_630090_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      stationId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Station_View/Station_ViewComponent_630090_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ZipFromLabels = result?.data.zipFromLabels;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.Station_ViewComponent_630090_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  Station_ViewComponent_630090_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.DownloadFile = await ReactSystemFunctions.downloadFile(
      ReactSystemFunctions.toString(this, this.state.ZipFromLabels),
      ReactSystemFunctions.toString(
        this,
        stateVars.GetStationDetail !== undefined
          ? stateVars.GetStationDetail?.length > 0
            ? stateVars.GetStationDetail[0].stationName
            : null
          : this.state.GetStationDetail?.length > 0
          ? this.state.GetStationDetail[0].stationName
          : null
      )
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  Station_ViewComponent_270670_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      stationId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "string"
      ),
      fileName_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationDetail !== undefined
            ? stateVars.GetStationDetail?.length > 0
              ? stateVars.GetStationDetail[0].stationName
              : null
            : this.state.GetStationDetail?.length > 0
            ? this.state.GetStationDetail[0].stationName
            : null
        ),
        "string"
      ),
      stationId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "string"
      ),
      cleanupDelaySeconds_1: ReactSystemFunctions.convertToTypeByName(
        60,
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Station_View/Station_ViewComponent_270670_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SaveStationLabelsZip = result?.data.saveStationLabelsZip;
    stateVars.PrepareDownloadLink = result?.data.prepareDownloadLink;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.Station_ViewComponent_270670_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  Station_ViewComponent_270670_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.OpenInBrowser = await ReactSystemFunctions.openInBrowser(
      ReactSystemFunctions.toString(this, this.state.PrepareDownloadLink),
      ReactSystemFunctions.convertToTypeByName("", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  Station_ViewComponent_136947_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].productsView
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].productsView
            : null
        ),
        true
      )
    ) {
      KuikaAppManager.showSpinner(this);

      KuikaAppManager.prepareForNavigation();
      KuikaAppManager.addToPageInputVariables(
        "STDProducts_View",
        "Id",
        ReactSystemFunctions.convertToTypeByName(
          ReactSystemFunctions.value(
            this,
            "station_view_654916_value",
            "productId"
          ),
          "Guid"
        )
      );

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        undefined,
        "Station_View",
        "STDProducts_View",
        "",
        "7d969ddf-5801-4eb6-b92b-12be35bdd565",
        "696892",
        null,
        "right",
        "true",
        "600px",
        "100vh",
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  Station_ViewComponent_74018_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "STDBoxes_Form",
      "Id",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "station_view_654916_value", "id"),
        "Guid"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "STDBoxes_Form",
      "stationId",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      this.Station_ViewComponent_74018_onClick1_,
      "Station_View",
      "STDBoxes_Form",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "678303",
      null,
      "right",
      "true",
      "500px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };
  Station_ViewComponent_74018_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      Search_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "station_view_995515_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Station_View/Station_ViewComponent_74018_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetStationsBoxByProductNameOrCode =
      result?.data.getStationsBoxByProductNameOrCode;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.Station_ViewComponent_74018_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  Station_ViewComponent_74018_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_654916 =
      stateVars.GetStationsBoxByProductNameOrCode ??
      this.state.GetStationsBoxByProductNameOrCode;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  Station_ViewComponent_511595_onActive = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      StationId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Station_View/Station_ViewComponent_511595_onActive",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetOrdersWithStationId = result?.data.getOrdersWithStationId;

    stateVars.isComp756824Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetOrdersWithStationId !== undefined
            ? stateVars.GetOrdersWithStationId?.length > 0
              ? stateVars.GetOrdersWithStationId[0].id
              : null
            : this.state.GetOrdersWithStationId?.length > 0
            ? this.state.GetOrdersWithStationId[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.Station_ViewComponent_511595_onActive1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  Station_ViewComponent_511595_onActive1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp663094Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );

    stateVars.dataSource_894388 =
      stateVars.GetOrdersWithStationId ?? this.state.GetOrdersWithStationId;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  Station_ViewComponent_351859_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      StationId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      value_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, stateVars.GetStationOrderForExcel),
        "any"
      ),
      header_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      footer_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      columns_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Station_View/Station_ViewComponent_351859_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetStationOrderForExcel = result?.data.getStationOrderForExcel;
    stateVars.ExportExcel = result?.data.exportExcel;
    ReactSystemFunctions.downloadFile(result?.data?.exportExcel);
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  Station_ViewComponent_756824_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      stationId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      userId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].kUserId
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].kUserId
            : null
        ),
        "string"
      ),
      sapUsername_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetSapInfos !== undefined
            ? stateVars.GetSapInfos?.length > 0
              ? stateVars.GetSapInfos[0].userName
              : null
            : this.state.GetSapInfos?.length > 0
            ? this.state.GetSapInfos[0].userName
            : null
        ),
        "string"
      ),
      sapPassword_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetSapInfos !== undefined
            ? stateVars.GetSapInfos?.length > 0
              ? stateVars.GetSapInfos[0].userPassword
              : null
            : this.state.GetSapInfos?.length > 0
            ? this.state.GetSapInfos[0].userPassword
            : null
        ),
        "string"
      ),
      StationId_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "Station_View/Station_ViewComponent_756824_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetSapInfos = result?.data.getSapInfos;
    stateVars.GetOrdersWithStationId = result?.data.getOrdersWithStationId;

    stateVars.isComp756824Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetOrdersWithStationId !== undefined
            ? stateVars.GetOrdersWithStationId?.length > 0
              ? stateVars.GetOrdersWithStationId[0].id
              : null
            : this.state.GetOrdersWithStationId?.length > 0
            ? this.state.GetOrdersWithStationId[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.Station_ViewComponent_756824_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  Station_ViewComponent_756824_onClick_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp756824Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  Station_ViewComponent_756824_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetOrdersWithStationId !== undefined
            ? stateVars.GetOrdersWithStationId?.length > 0
              ? stateVars.GetOrdersWithStationId[0].id
              : null
            : this.state.GetOrdersWithStationId?.length > 0
            ? this.state.GetOrdersWithStationId[0].id
            : null
        ),
        true
      )
    ) {
      isErrorOccurred = await this.Station_ViewComponent_756824_onClick_if1();
      if (isErrorOccurred) return true;
    } else {
    }

    stateVars.dataSource_894388 =
      stateVars.GetOrdersWithStationId ?? this.state.GetOrdersWithStationId;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  Station_ViewComponent_125422_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].boxView
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].boxView
            : null
        ),
        true
      )
    ) {
      KuikaAppManager.showSpinner(this);

      KuikaAppManager.prepareForNavigation();
      KuikaAppManager.addToPageInputVariables(
        "STDBoxes_Details",
        "Id",
        ReactSystemFunctions.convertToTypeByName(
          ReactSystemFunctions.value(
            this,
            "station_view_894388_value",
            "boxId"
          ),
          "Guid"
        )
      );
      KuikaAppManager.addToPageInputVariables(
        "STDBoxes_Details",
        "stationId",
        ReactSystemFunctions.convertToTypeByName(
          ReactSystemFunctions.value(
            this,
            "station_view_894388_value",
            "stationId"
          ),
          "Guid"
        )
      );

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        undefined,
        "Station_View",
        "STDBoxes_Details",
        "",
        "7d969ddf-5801-4eb6-b92b-12be35bdd565",
        "801996",
        null,
        "right",
        "true",
        "602px",
        "100vh",
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  Station_ViewComponent_195078_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "BoxLogs",
      "BoxId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "station_view_894388_value", "boxId"),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Station_View",
      "BoxLogs",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "727109",
      null,
      "right",
      "true",
      "500px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  Station_ViewComponent_543229_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "BoxLogs",
      "BoxId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "station_view_894388_value", "boxId"),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Station_View",
      "BoxLogs",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "303502",
      null,
      "right",
      "true",
      "500px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  Station_ViewComponent_630893_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "BoxLogs",
      "BoxId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "station_view_894388_value", "boxId"),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Station_View",
      "BoxLogs",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "642323",
      null,
      "right",
      "true",
      "500px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  Station_ViewComponent_615348_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "BoxLogs",
      "BoxId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "station_view_894388_value", "boxId"),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "Station_View",
      "BoxLogs",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "132758",
      null,
      "right",
      "true",
      "500px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  Station_ViewComponent_136947_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (
      KuikaAppManager.handleValidations(this, validations, this.checkTabErrors)
    ) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [
      ,
      ,
      16963,
      332376,
      546395,
      518991,
      265858,
      696892,
      678303,
      801996,
      727109,
      303502,
      642323,
      132758,
    ] as number[];
    if (
      isFromMaster ||
      ((window.kuika?.disableSmartExecutePageInit?.["Station_View"] ?? false) &&
        pageInitCallerNavDiIDs.indexOf(diId) > -1)
    ) {
      await this.Station_ViewPageInit();
    } else if (
      window.kuika?.serverRequestCount > 0 &&
      pageInitCallerNavDiIDs.indexOf(diId) > -1
    ) {
      await this.Station_ViewPageInit();
    }
    if (diId == 265858) {
      isErrorOccurred = await this.Station_ViewComponent_271722_onClick1_();
      if (isErrorOccurred) return true;
    } else if (diId == 678303) {
      isErrorOccurred = await this.Station_ViewComponent_74018_onClick1_();
      if (isErrorOccurred) return true;
    }
  }
}
